import script from "./BaseTag.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTag.vue?vue&type=script&setup=true&lang=js"

import "./BaseTag.vue?vue&type=style&index=0&id=10c74a52&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10c74a52"]])

export default __exports__